export const DEFAULT_FAVICON_HREF = "/favicon.ico";
export const DEV_FAVICON_HREF = "/favicon-dev.ico";

const LOCAL_DEV_HOSTNAMES = new Set(["localhost", "127.0.0.1", "::1"]);
const DEVELOPMENT_VALUES = new Set(["development", "dev", "local"]);

function normalizeEnvironmentValue(value) {
    return String(value || "").trim().toLowerCase();
}

function getRuntimeEnvironment() {
    const processEnv =
        typeof process !== "undefined" && process.env ? process.env : {};
    const viteEnv = import.meta.env || {};

    return {
        nodeEnv: processEnv.NODE_ENV,
        viteDev: viteEnv.DEV,
        viteMode: viteEnv.MODE,
        viteEnv: processEnv.VITE_ENV || viteEnv.VITE_ENV,
        viteEnvironment:
            processEnv.VITE_ENVIRONMENT || viteEnv.VITE_ENVIRONMENT,
    };
}

export function isDevelopmentFaviconMode({
    hostname = "",
    nodeEnv,
    viteDev,
    viteMode,
    viteEnv,
    viteEnvironment,
} = {}) {
    if (viteDev === true || LOCAL_DEV_HOSTNAMES.has(hostname)) {
        return true;
    }

    return [nodeEnv, viteMode, viteEnv, viteEnvironment].some((value) =>
        DEVELOPMENT_VALUES.has(normalizeEnvironmentValue(value))
    );
}

export function applyDevelopmentFavicon({
    documentRef = typeof document !== "undefined" ? document : null,
    locationRef = typeof window !== "undefined" ? window.location : null,
    environment = getRuntimeEnvironment(),
} = {}) {
    if (!documentRef) {
        return false;
    }

    const hostname = locationRef?.hostname || "";
    if (!isDevelopmentFaviconMode({ ...environment, hostname })) {
        return false;
    }

    const faviconLink =
        documentRef.querySelector('link[rel="icon"]') ||
        documentRef.querySelector('link[rel~="icon"]');

    if (!faviconLink) {
        return false;
    }

    faviconLink.setAttribute("href", DEV_FAVICON_HREF);
    return true;
}
